import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, FormControl, UntypedFormControl } from '@angular/forms';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HeadService } from 'src/app/services/common/headservice';
import * as $ from 'jquery';
import { ModuleMenu } from 'src/app/models/common';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';

@Component({
  selector: 'app-grants-general-information',
  templateUrl: './grants-general-information.component.html',
  styleUrls: ['./grants-general-information.component.scss']
})
export class GrantsGeneralInformationComponent implements OnInit , IDeactivateComponent {

  generalInformationForm: UntypedFormGroup;
  permission: string = "";
  staticformFields: any;
  IS_PREIOR_REQ: any[];
  IS_AFFILIATE_PRO: any[];
  IS_PREV_YEAR: any[];
  IS_EXHIBIT_OPPORTUNITY: any[];
  IS_OTH_CORPORATES: any[];
  action: Subject<any> = new Subject();
  userType: string = "";
  heading: string;
  operations: any = [];
  ApplicationID: any;
  menudata: ModuleMenu;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  Application_Type_ID: string="";
  constructor(
    public commonService: CommonService,
    private userService: UserService,
    private DatashareSerivce: GrantsDatashareService,
    private summaryService: GrantsSummaryService,
    public route: ActivatedRoute,
    private router: Router,
    private header: HeadService,
  ) {
    this.Application_Type_ID = route.snapshot.queryParams['ApplicationType'];
  }

  ngOnInit() {
    
    this.userType = this.userService.getUserType();
    this.DatashareSerivce.GrantApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.getStaticFiledsData('GC01');   
    this.generalInformationForm = new UntypedFormGroup(
      {
        ID: new UntypedFormControl(""),
        APPLICATION_TITLE: new UntypedFormControl(""),
        APPLICATION_CODE: new UntypedFormControl(""),
        APPLICATIONID: new UntypedFormControl(""),
        MED_EDU_GRANTS: new UntypedFormControl(""),
        IS_PREIOR_REQ: new UntypedFormControl(""),
        LAST_REQ_SUBMIT: new UntypedFormControl(""),
        IS_AFFILIATE_PRO: new UntypedFormControl(""),
        IS_PREV_YEAR: new UntypedFormControl(""),
        IS_EXHIBIT_OPPORTUNITY: new UntypedFormControl(""),
        IS_OTH_CORPORATES: new UntypedFormControl("") ,
        IS_OTH_CORPORATES_DESC: new UntypedFormControl(""),
        RFP_CODE: new UntypedFormControl(""),
        ANNUAL_REVENUE: new UntypedFormControl(""),
        TOTAL_EMPLOYEES: new UntypedFormControl(""),
        TOTAL_YEARS: new UntypedFormControl("")
      });
      this.generalInformationForm.markAsPristine();  
      // setTimeout(() => { 
      //   //this.setFormPermissions();
      //   if (this.permission == "view") {
      //     this.generalInformationForm.disable();           
      //   }
      //   else if(this.generalInformationForm!=null &&  this.generalInformationForm!=undefined)
      //   {
      //     this.generalInformationForm.enable();
      //   }
      // }, 700);
      
    this.summaryService.getGeneralInformationCME("api/GMAPPCME/Edit?RecordID=" + this.ApplicationID).subscribe((summary) => {

      if (summary != null && summary != undefined) {  
        
        this.generalInformationForm.patchValue({
          ID: summary["ID"],
          APPLICATION_TITLE: summary["APPLICATION_TITLE"],
          APPLICATION_CODE: summary["APPLICATION_CODE"],
          APPLICATIONID: summary["APPLICATIONID"],
          MED_EDU_GRANTS: summary["MED_EDU_GRANTS"],
          IS_PREIOR_REQ: summary["IS_PREIOR_REQ"],
          LAST_REQ_SUBMIT:summary["LAST_REQ_SUBMIT"],
          IS_AFFILIATE_PRO: summary["IS_AFFILIATE_PRO"],
          IS_PREV_YEAR: summary["IS_PREV_YEAR"],
          IS_EXHIBIT_OPPORTUNITY: summary["IS_EXHIBIT_OPPORTUNITY"],
          IS_OTH_CORPORATES: summary["IS_OTH_CORPORATES"],
          IS_OTH_CORPORATES_DESC: summary["IS_OTH_CORPORATES_DESC"],
          RFP_CODE: summary["RFP_CODE"],
          ANNUAL_REVENUE: summary["ANNUAL_REVENUE"],
          TOTAL_EMPLOYEES: summary["TOTAL_EMPLOYEES"],
          TOTAL_YEARS: summary["TOTAL_YEARS"]
        });
        this.extendedForm.rowid = summary["ID"];
        this.extendedForm.getResponse();
        this.permission = summary["PERMISSION"];
        this.setFormPermissions();
      }
    });

    this.commonService.getGlobalDirtyInfo().subscribe((res)=>{
      if(res==true){
        this.generalInformationForm.markAsPristine();
         this.extendedForm.IsFormToched=false;
      }
    });
 }

 private setFormPermissions() {     
 //this.permission = this.commonService.getPagePermission("GC01");
  if (this.permission == "view") {
    if (this.extendedForm != null && this.extendedForm != undefined) {
      this.extendedForm.permission = this.permission;
      this.extendedForm.ScreenMode = this.permission;
    }
   // this.generalInformationForm.disable();
  }   

if (this.permission == "view") {
  //this.generalInformationForm.disable();
  this.operations = [];
}
else {
  this.operations = [
    {
      name: 'SaveGeneralInfo', type: 'submit', callback: this.SaveGeneralInfo, self: this
    }
  ];
}
if (this.permission == "view" &&  this.generalInformationForm!=null &&  this.generalInformationForm!=undefined) {
  this.generalInformationForm.disable();           
}
else if(this.generalInformationForm!=null &&  this.generalInformationForm!=undefined)
{
  this.generalInformationForm.enable();
}
}

 getStaticFiledsData(screenCode:string) {
  this.commonService.getScreenStaticFields(screenCode,this.ApplicationID)
    .subscribe(summary => {
      this.staticformFields = summary["Data"];
      this.IS_PREIOR_REQ=this.staticformFields.IS_PREIOR_REQ.GROUP_VALUES_LIST;
      this.IS_PREIOR_REQ = [{ label: "Select", value: null, checked: true }].concat(this.IS_PREIOR_REQ);
      this.IS_AFFILIATE_PRO =this.staticformFields.IS_AFFILIATE_PRO.GROUP_VALUES_LIST;
      this.IS_AFFILIATE_PRO = [{ label: "Select", value: null, checked: true }].concat(this.IS_AFFILIATE_PRO);
      this.IS_PREV_YEAR = this.staticformFields.IS_PREV_YEAR.GROUP_VALUES_LIST;
      this.IS_PREV_YEAR = [{ label: "Select", value: null, checked: true }].concat(this.IS_PREV_YEAR);
      this.IS_EXHIBIT_OPPORTUNITY = this.staticformFields.IS_EXHIBIT_OPPORTUNITY.GROUP_VALUES_LIST;
      this.IS_EXHIBIT_OPPORTUNITY = [{ label: "Select", value: null, checked: true }].concat(this.IS_EXHIBIT_OPPORTUNITY);
      this.IS_OTH_CORPORATES = this.staticformFields.IS_OTH_CORPORATES.GROUP_VALUES_LIST;
      this.IS_OTH_CORPORATES = [{ label: "Select", value: null, checked: true }].concat(this.IS_OTH_CORPORATES);
    });
}

onCallbackOperation(opr) {
  opr.callback(this.summaryService, this.generalInformationForm, this.DatashareSerivce);
}

PR_REQSelectionChanged(newValue) {
  if (this.generalInformationForm.controls['IS_PREIOR_REQ'].value == "1") {
   // this.generalInformationForm.controls['LAST_REQ_SUBMIT'].setValue("");
  }
}

OT_CORSelectionChanged(newValue) {
  if (this.generalInformationForm.controls['IS_OTH_CORPORATES'].value == "1") {
  //  this.generalInformationForm.controls['IS_OTH_CORPORATES_DESC'].setValue("");
  }
}

SaveGeneralInfo() {
  if (this.validateControls()) {
    this.generalInformationForm.markAsPristine();
    var formData = this.generalInformationForm.value;
    formData.APPLICATION_TITLE =formData.APPLICATION_TITLE==null?null:formData.APPLICATION_TITLE==undefined?undefined:formData.APPLICATION_TITLE.trim();
    formData.MED_EDU_GRANTS=formData.MED_EDU_GRANTS==null?null:formData.MED_EDU_GRANTS==undefined?undefined:formData.MED_EDU_GRANTS.trim();
    formData.LAST_REQ_SUBMIT=formData.LAST_REQ_SUBMIT==null?null:formData.LAST_REQ_SUBMIT==undefined?undefined:formData.LAST_REQ_SUBMIT.trim();
    formData.IS_OTH_CORPORATES_DESC=formData.IS_OTH_CORPORATES_DESC==null?null:formData.IS_OTH_CORPORATES_DESC==undefined?undefined: formData.IS_OTH_CORPORATES_DESC.trim();
    formData.ANNUAL_REVENUE=formData.ANNUAL_REVENUE==null?null:formData.ANNUAL_REVENUE==undefined?undefined:formData.ANNUAL_REVENUE.trim();
    formData.TOTAL_EMPLOYEES=formData.TOTAL_EMPLOYEES==null?null:formData.TOTAL_EMPLOYEES==undefined?undefined:formData.TOTAL_EMPLOYEES.trim();
    formData.RFP_CODE=formData.RFP_CODE==null?null:formData.RFP_CODE==undefined?undefined:formData.RFP_CODE.trim();
    formData.TOTAL_YEARS= formData.TOTAL_YEARS==null?null:formData.TOTAL_YEARS==undefined?undefined:formData.TOTAL_YEARS.trim();
    this.IS_PREIOR_REQ.forEach(obj => {
      if (obj.value!=null && obj.value!="" && formData["IS_PREIOR_REQ"] == obj.value) {
        formData.IS_PREIOR_REQ_NAME = obj.label;
      }
    });
    this.IS_AFFILIATE_PRO.forEach(obj => {
      if (obj.value!=null && obj.value!="" && formData["IS_AFFILIATE_PRO"] == obj.value) {
        formData.IS_AFFILIATE_PRO_NAME = obj.label;
      }
    });
    this.IS_PREV_YEAR.forEach(obj => {
      if (obj.value!=null && obj.value!="" && formData["IS_PREV_YEAR"] == obj.value) {
        formData.IS_PREV_YEAR_NAME = obj.label;
      }
    });
    this.IS_EXHIBIT_OPPORTUNITY.forEach(obj => {
      if (obj.value!=null && obj.value!="" && formData["IS_EXHIBIT_OPPORTUNITY"] == obj.value) {
        formData.IS_EXHIBIT_OPPORTUNITY_NAME = obj.label;
      }
    });
    this.IS_OTH_CORPORATES.forEach(obj => {
      if (obj.value!=null && obj.value!="" && formData["IS_OTH_CORPORATES"] == obj.value) {
        formData.IS_OTH_CORPORATES_NAME = obj.label;
      }
    });
    if (this.ApplicationID == "" || this.ApplicationID == undefined) {
     formData.Application_Type_ID=this.Application_Type_ID;
      this.summaryService.SaveCMEGeneralInfo("api/GMAPPCME/Insert", formData).subscribe((result) => {
        var tempID = result.Data;
        this.ApplicationID = result.Data;
        this.DatashareSerivce.setGrantApplicationID(tempID);
        this.extendedForm.IsFormToched=false;
        if (result.Status === 0) {
              this.extendedForm.saveControls(result.TransactionID, tempID, result.TransactionCode).subscribe(result1 => {
                if (result1.Status === 0) {
                  if (this.extendedForm != null && this.extendedForm != undefined) {
                    this.extendedForm.rowid=result.TransactionID;
                    this.extendedForm.getResponse();
                  }
                  this.generalInformationForm.markAsPristine();
                  this.commonService.SuccessBanner(result.Message);
                  this.refreshPage(tempID,result.TransactionID);
                }
                else {
                  this.commonService.ValidationBanner(result1.Message);
                  this.refreshPage(tempID,result.TransactionID);
                  if (this.extendedForm != null && this.extendedForm != undefined) {
                    this.extendedForm.rowid=result.TransactionID;
                    this.extendedForm.getResponse();
                  }
                }
              });

        }
        else {
          this.commonService.ValidationBanner(result.Message);
        }
      });
    }
    else {
            this.summaryService.SaveCMEGeneralInfo("api/GMAPPCME/Update", formData).subscribe((result) => {
              if (result.Status === 0 || result.ErrorCode === "NOCHANGES") {
                    this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
                      if (result1.ErrorCode === "NOCONTROLS") {
                        if (result.ErrorCode === "NOCHANGES")
                          this.commonService.ValidationBanner(result.Message);
                        else
                        {
                          this.generalInformationForm.markAsPristine();
                          this.commonService.SuccessBanner("General Information saved successfully");
                          this.extendedForm.IsFormToched=false;
                          if (this.extendedForm != null && this.extendedForm != undefined) {
                            this.extendedForm.rowid=result.TransactionID;
                            this.extendedForm.getResponse();
                          }
                        }
                      }
                      else {
                        if (result.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                          this.commonService.ValidationBanner(result.Message);
                        }
                        else {
                          this.generalInformationForm.markAsPristine();
                          this.commonService.SuccessBanner("General Information saved successfully");
                          this.extendedForm.IsFormToched=false;
                          if (this.extendedForm != null && this.extendedForm != undefined) {
                            this.extendedForm.rowid=result.TransactionID;
                            this.extendedForm.getResponse();
                          }
                        }
                      }

                    });

              }
              else {
                this.commonService.ValidationBanner(result.Message);
              }
            });
    }
  }
}

refreshPage(AppId: any,PKID:any) {
  this.summaryService.getCMEApplicationSummary("api/common/getgrantsapp/" + AppId).subscribe(data => {
    this.commonService.appId = AppId;
    this.commonService.ScreenID = PKID;
    this.commonService.setGrantsApp(data);
    this.menudata = new ModuleMenu();
    this.menudata.module = "GRANTSCME";
    this.menudata.operation = "Edit";
    this.menudata.appId = AppId;
    this.menudata.screenID=PKID;
    this.menudata.formstate = "Draft";
    this.commonService.setModluleMenu(this.menudata);
    this.header.setHeader(this.menudata);
    this.generalInformationForm.patchValue({
      ID: PKID});
      this.router.navigate(['/home/grants/my-applications/application-ext/:'+AppId+'/'+data.StartMenu], { skipLocationChange: true, queryParams: { module: "grants",submodule:this.menudata.module, id: PKID, app_ext: true, screen_type: "my-applications" }
    });

  });
  this.generalInformationForm.markAsPristine();
}

redirectTo(uri: string) {
  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    this.router.navigate([uri]));
}

validateControls(): boolean {
  let isValid = true;
  let message = "";
  const formData = this.generalInformationForm.value;
if (this.staticformFields?.APPLICATION_TITLE?.IS_Display && this.staticformFields?.APPLICATION_TITLE.IS_MANDATORY) {
  if (formData.APPLICATION_TITLE === null || formData.APPLICATION_TITLE === ""||formData.APPLICATION_TITLE=== undefined) {
    $("#APPLICATION_TITLE").addClass("ng-touched ng-invalid validate-error");
    $("#APPLICATION_TITLE").removeClass("ng-untouched ng-valid");
    message += `Please enter ${this.staticformFields?.APPLICATION_TITLE.LABEL_NAME} <br/>`;
    isValid = false;
  }else if(formData.APPLICATION_TITLE != null&& formData.APPLICATION_TITLE!= undefined && formData.APPLICATION_TITLE.trim()==""){
    $("#APPLICATION_TITLE").addClass("ng-touched ng-invalid validate-error");
    $("#APPLICATION_TITLE").removeClass("ng-untouched ng-valid");
    message += `Please enter ${this.staticformFields?.APPLICATION_TITLE.LABEL_NAME} <br/>`;
    isValid = false;
  } 
  else {
    $("#APPLICATION_TITLE").addClass("ng-untouched ng-valid");
    $("#APPLICATION_TITLE").removeClass("ng-touched ng-invalid validate-error");
  }
}
  if (this.staticformFields?.MED_EDU_GRANTS?.IS_Display && this.staticformFields?.MED_EDU_GRANTS.IS_MANDATORY) {
    if (formData.MED_EDU_GRANTS === null || formData.MED_EDU_GRANTS === ""||formData.MED_EDU_GRANTS===undefined) {
      $("#MED_EDU_GRANTS").addClass("ng-touched ng-invalid validate-error");
      $("#MED_EDU_GRANTS").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.MED_EDU_GRANTS.LABEL_NAME} <br/>`;
      isValid = false;
    }else if(formData.MED_EDU_GRANTS != null && formData.MED_EDU_GRANTS != undefined && formData.MED_EDU_GRANTS.trim()==""){
      $("#MED_EDU_GRANTS").addClass("ng-touched ng-invalid validate-error");
      $("#MED_EDU_GRANTS").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.MED_EDU_GRANTS.LABEL_NAME} <br/>`;
      isValid = false;
    } 
    else {
      $("#MED_EDU_GRANTS").addClass("ng-untouched ng-valid");
      $("#MED_EDU_GRANTS").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_PREIOR_REQ?.IS_Display) 
  {
    if (this.staticformFields?.IS_PREIOR_REQ.IS_MANDATORY && (formData.IS_PREIOR_REQ === null || formData.IS_PREIOR_REQ === ""))  {
      $("#IS_PREIOR_REQ").addClass("ng-touched ng-invalid validate-error");
      $("#IS_PREIOR_REQ").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_PREIOR_REQ.LABEL_NAME} <br/>`;
      isValid = false;
    } 
    else 
    {
      
  if (this.staticformFields?.LAST_REQ_SUBMIT?.IS_Display && this.staticformFields?.LAST_REQ_SUBMIT.IS_MANDATORY) 
  {
    if (formData.IS_PREIOR_REQ ==="1" && this.staticformFields?.IS_PREIOR_REQ?.IS_Display)
    {
    if (formData.LAST_REQ_SUBMIT === null || formData.LAST_REQ_SUBMIT === "" || formData.LAST_REQ_SUBMIT === "Select") {
      $("#LAST_REQ_SUBMIT").addClass("ng-touched ng-invalid validate-error");
      $("#LAST_REQ_SUBMIT").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.LAST_REQ_SUBMIT.LABEL_NAME} <br/>`;
      isValid = false;
    }else if(formData.LAST_REQ_SUBMIT != null && formData.LAST_REQ_SUBMIT != undefined && formData.LAST_REQ_SUBMIT.trim()==""){
      $("#LAST_REQ_SUBMIT").addClass("ng-touched ng-invalid validate-error");
      $("#LAST_REQ_SUBMIT").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.LAST_REQ_SUBMIT.LABEL_NAME} <br/>`;
      isValid = false;
    } 
    else {
      $("#LAST_REQ_SUBMIT").addClass("ng-untouched ng-valid");
      $("#LAST_REQ_SUBMIT").removeClass("ng-touched ng-invalid validate-error");
    }
  }   
  }
  else {
    $("#LAST_REQ_SUBMIT").addClass("ng-untouched ng-valid");
    $("#LAST_REQ_SUBMIT").removeClass("ng-touched ng-invalid validate-error");
  }
  $("#IS_PREIOR_REQ").addClass("ng-untouched ng-valid");
      $("#IS_PREIOR_REQ").removeClass("ng-touched ng-invalid validate-error");
}
}

  if (this.staticformFields?.IS_AFFILIATE_PRO?.IS_Display && this.staticformFields?.IS_AFFILIATE_PRO.IS_MANDATORY) {
    if (formData.IS_AFFILIATE_PRO === null || formData.IS_AFFILIATE_PRO === "") {
      $("#IS_AFFILIATE_PRO").addClass("ng-touched ng-invalid validate-error");
      $("#IS_AFFILIATE_PRO").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_AFFILIATE_PRO.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_AFFILIATE_PRO").addClass("ng-untouched ng-valid");
      $("#IS_AFFILIATE_PRO").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_PREV_YEAR?.IS_Display && this.staticformFields?.IS_PREV_YEAR.IS_MANDATORY) {
    if (formData.IS_PREV_YEAR === null || formData.IS_PREV_YEAR === "") {
      $("#IS_PREV_YEAR").addClass("ng-touched ng-invalid validate-error");
      $("#IS_PREV_YEAR").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_PREV_YEAR.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_PREV_YEAR").addClass("ng-untouched ng-valid");
      $("#IS_PREV_YEAR").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_EXHIBIT_OPPORTUNITY?.IS_Display && this.staticformFields?.IS_EXHIBIT_OPPORTUNITY.IS_MANDATORY) {
    if (formData.IS_EXHIBIT_OPPORTUNITY === null || formData.IS_EXHIBIT_OPPORTUNITY === "") {
      $("#IS_EXHIBIT_OPPORTUNITY").addClass("ng-touched ng-invalid validate-error");
      $("#IS_EXHIBIT_OPPORTUNITY").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_EXHIBIT_OPPORTUNITY.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_EXHIBIT_OPPORTUNITY").addClass("ng-untouched ng-valid");
      $("#IS_EXHIBIT_OPPORTUNITY").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_OTH_CORPORATES?.IS_Display && this.staticformFields?.IS_OTH_CORPORATES.IS_MANDATORY) {
    if (formData.IS_OTH_CORPORATES === null || formData.IS_OTH_CORPORATES === "") {
      $("#IS_OTH_CORPORATES").addClass("ng-touched ng-invalid validate-error");
      $("#IS_OTH_CORPORATES").removeClass("ng-untouched ng-valid");
      message += `Please select ${this.staticformFields?.IS_OTH_CORPORATES.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#IS_OTH_CORPORATES").addClass("ng-untouched ng-valid");
      $("#IS_OTH_CORPORATES").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.IS_OTH_CORPORATES_DESC?.IS_Display) {
    if (formData.IS_OTH_CORPORATES ==="1")
    {
    if (this.staticformFields?.IS_OTH_CORPORATES_DESC.IS_MANDATORY && (formData.IS_OTH_CORPORATES_DESC === null || formData.IS_OTH_CORPORATES_DESC === "")) {
      $("#IS_OTH_CORPORATES_DESC").addClass("ng-touched ng-invalid validate-error");
      $("#IS_OTH_CORPORATES_DESC").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.IS_OTH_CORPORATES_DESC.LABEL_NAME} <br/>`;
      isValid = false;
    }else if(formData.IS_OTH_CORPORATES_DESC != null && formData.IS_OTH_CORPORATES_DESC!= undefined && formData.IS_OTH_CORPORATES_DESC.trim()==""){
      $("#IS_OTH_CORPORATES_DESC").addClass("ng-touched ng-invalid validate-error");
      $("#IS_OTH_CORPORATES_DESC").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.IS_OTH_CORPORATES_DESC.LABEL_NAME} <br/>`;
      isValid = false;
    } 
    else {
      $("#IS_OTH_CORPORATES_DESC").addClass("ng-untouched ng-valid");
      $("#IS_OTH_CORPORATES_DESC").removeClass("ng-touched ng-invalid validate-error");
    }
  }
  else {
    $("#IS_OTH_CORPORATES_DESC").addClass("ng-untouched ng-valid");
    $("#IS_OTH_CORPORATES_DESC").removeClass("ng-touched ng-invalid validate-error");
  }
}

  if (this.staticformFields?.RFP_CODE?.IS_Display && this.staticformFields?.RFP_CODE.IS_MANDATORY) {
    if (formData.RFP_CODE === null || formData.RFP_CODE === ""||formData.RFP_CODE===undefined) {
      $("#RFP_CODE").addClass("ng-touched ng-invalid validate-error");
      $("#RFP_CODE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.RFP_CODE.LABEL_NAME} <br/>`;
      isValid = false;
    }else if(formData.RFP_CODE != null && formData.RFP_CODE != undefined && formData.RFP_CODE.trim()== ""){
      $("#RFP_CODE").addClass("ng-touched ng-invalid validate-error");
      $("#RFP_CODE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.RFP_CODE.LABEL_NAME} <br/>`;
      isValid = false;
    } 
    else {
      $("#RFP_CODE").addClass("ng-untouched ng-valid");
      $("#RFP_CODE").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.ANNUAL_REVENUE?.IS_Display && this.staticformFields?.ANNUAL_REVENUE.IS_MANDATORY) {
    if (formData.ANNUAL_REVENUE === null || formData.ANNUAL_REVENUE === ""||formData.ANNUAL_REVENUE===undefined) {
      $("#ANNUAL_REVENUE").addClass("ng-touched ng-invalid validate-error");
      $("#ANNUAL_REVENUE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.ANNUAL_REVENUE.LABEL_NAME} <br/>`;
      isValid = false;
    }else if(formData.ANNUAL_REVENUE != null&&formData.ANNUAL_REVENUE!= undefined&& formData.ANNUAL_REVENUE.trim()==""){
      $("#ANNUAL_REVENUE").addClass("ng-touched ng-invalid validate-error");
      $("#ANNUAL_REVENUE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.ANNUAL_REVENUE.LABEL_NAME} <br/>`;
      isValid = false;
    } 
    else {
      $("#ANNUAL_REVENUE").addClass("ng-untouched ng-valid");
      $("#ANNUAL_REVENUE").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.TOTAL_EMPLOYEES?.IS_Display && this.staticformFields?.TOTAL_EMPLOYEES.IS_MANDATORY) {
    if (formData.TOTAL_EMPLOYEES === null || formData.TOTAL_EMPLOYEES === ""||formData.TOTAL_EMPLOYEES===undefined) {
      $("#TOTAL_EMPLOYEES").addClass("ng-touched ng-invalid validate-error");
      $("#TOTAL_EMPLOYEES").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.TOTAL_EMPLOYEES.LABEL_NAME} <br/>`;
      isValid = false;
    }else if(formData.TOTAL_EMPLOYEES!= null && formData.TOTAL_EMPLOYEES!= undefined &&formData.TOTAL_EMPLOYEES.trim()==""){
      $("#TOTAL_EMPLOYEES").addClass("ng-touched ng-invalid validate-error");
      $("#TOTAL_EMPLOYEES").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.TOTAL_EMPLOYEES.LABEL_NAME} <br/>`;
      isValid = false;
    } 
    else {
      $("#TOTAL_EMPLOYEES").addClass("ng-untouched ng-valid");
      $("#TOTAL_EMPLOYEES").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.TOTAL_YEARS?.IS_Display && this.staticformFields?.TOTAL_YEARS.IS_MANDATORY) {
    if (formData.TOTAL_YEARS === null || formData.TOTAL_YEARS === ""||formData.TOTAL_YEARS=== undefined) {
      $("#TOTAL_YEARS").addClass("ng-touched ng-invalid validate-error");
      $("#TOTAL_YEARS").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.TOTAL_YEARS.LABEL_NAME} <br/>`;
      isValid = false;
    }else if(formData.TOTAL_YEARS != null && formData.TOTAL_YEARS != undefined && formData.TOTAL_YEARS.trim()==""){
      $("#TOTAL_YEARS").addClass("ng-touched ng-invalid validate-error");
      $("#TOTAL_YEARS").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.TOTAL_YEARS.LABEL_NAME} <br/>`;
      isValid = false;
    } 
    else {
      $("#TOTAL_YEARS").addClass("ng-untouched ng-valid");
      $("#TOTAL_YEARS").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  let ExtenMsgs = this.extendedForm.validateControlsMsgs();
  if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
    isValid = false;
    message = message + this.extendedForm.validateControlsMsgs();
  }

  if (!isValid)
    this.commonService.ValidationBanner(message);
  return isValid;
}

canExit() {
  if (this.generalInformationForm.dirty || this.extendedForm.IsFormToched) {
    return this.commonService.CanDeactivateBanner();
  }
  else {
    return Promise.resolve(true);
  }
}

}
